/* Corsaille Knowledge — Pass 44. Dependency-free, progressive enhancement only. */
(() => {
  'use strict';
  const slugify = value => value.toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');

  // Standalone article table of contents.
  const article = document.querySelector('[data-ck-article-body]');
  const toc = document.querySelector('[data-ck-toc]');
  if (article && toc) {
    const headings = [...article.querySelectorAll('h2, h3')];
    const list = toc.matches('ol') ? toc : toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${slugify(heading.textContent) || 'sectiune'}-${index + 1}`;
      const li = document.createElement('li');
      li.className = heading.tagName === 'H3' ? 'is-sub' : '';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      li.appendChild(link);
      list.appendChild(li);
    });
    const links = [...list.querySelectorAll('a')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const active = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top-b.boundingClientRect.top)[0];
        if (!active) return;
        links.forEach(link => link.setAttribute('aria-current', String(link.hash === `#${active.target.id}`)));
      }, {rootMargin:'-18% 0px -70% 0px',threshold:[0,1]});
      headings.forEach(heading => observer.observe(heading));
    }
  }

  const faq = document.querySelector('[data-ck-faq]');
  if (faq) {
    const faqInput = faq.querySelector('[data-ck-faq-search]');
    const faqItems = [...faq.querySelectorAll('[data-ck-faq-item]')];
    const faqEmpty = faq.querySelector('[data-ck-faq-empty]');
    faqInput?.addEventListener('input', () => {
      const query = slugify(faqInput.value).replace(/-/g, ' ');
      let visible = 0;
      faqItems.forEach(item => {
        const text = slugify(item.textContent).replace(/-/g, ' ');
        const show = !query || query.split(/\s+/).every(token => text.includes(token));
        item.hidden = !show;
        if (show) visible++;
      });
      if (faqEmpty) faqEmpty.hidden = visible > 0;
    });
  }

  const library = document.querySelector('[data-ck-library]');
  if (!library) return;
  const originalTitle = document.title;
  const input = document.querySelector('[data-ck-global-input]');
  const filters = [...document.querySelectorAll('[data-ck-global-filters] [data-ck-filter]')];
  const chapters = [...library.querySelectorAll('[data-ck-chapter]')];
  const indexItems = [...library.querySelectorAll('[data-ck-index]')];
  const empty = library.querySelector('[data-ck-empty]');
  const status = library.querySelector('[data-ck-search-status]');
  let category = 'all';
  const normalize = value => (value || '').toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const synonyms = {
    'inel':['verigheta','bijuterie','montura'], 'diamant':['piatra','carat','claritate','culoare','taietura'],
    'alb':['culoare','d','e','f','g','h'], 'mare':['carataj','dimensiune','milimetri'],
    'rezistent':['durabil','zilnic','protectie','bezel'], 'ieftin':['buget','valoare','pret'],
    'oval':['bow-tie','alungit'], 'certificat':['raport','gia','igi','inscriptie'],
    'laborator':['lab-grown','creat in laborator','cvd','hpht'], 'natural':['origine','minat']
  };
  const expandQuery = value => {
    const raw = normalize(value).trim(); if (!raw) return [];
    const tokens = raw.split(/\s+/).filter(Boolean);
    return [...new Set(tokens.flatMap(token => [token, ...(synonyms[token] || [])].map(normalize)))];
  };

  const reader = document.createElement('div');
  reader.className = 'ck-reader-bar';
  reader.innerHTML = '<button class="ck-reader-bar__back" type="button" data-ck-reader-back>← Biblioteca</button><div class="ck-reader-bar__title" data-ck-reader-title></div><div class="ck-reader-bar__actions"><button class="ck-reader-bar__action" type="button" data-ck-copy>Copiează linkul</button><button class="ck-reader-bar__action" type="button" data-ck-print>Printează</button></div>';
  library.prepend(reader);

  const makeMeta = chapter => {
    if (chapter.querySelector('.ck-guide-meta')) return;
    const categoryName = chapter.dataset.category || 'Ghid';
    const sections = chapter.querySelectorAll('.ck-chapter__body > section').length;
    const words = (chapter.querySelector('.ck-chapter__body')?.textContent || '').trim().split(/\s+/).length;
    const minutes = Math.max(2, Math.ceil(words / 180));
    const meta = document.createElement('div');
    meta.className = 'ck-guide-meta';
    meta.innerHTML = `<span>${categoryName}</span><span>${minutes} min</span><span>${sections} repere</span>`;
    chapter.querySelector('.ck-chapter__intro')?.appendChild(meta);
  };
  chapters.forEach(makeMeta);

  // Prev/next navigation is generated from the canonical index order.
  const guideNav = document.createElement('nav');
  guideNav.className = 'ck-guide-nav'; guideNav.setAttribute('aria-label','Ghid anterior și următor');
  library.appendChild(guideNav);

  const setReading = id => {
    const target = chapters.find(chapter => chapter.id === id);
    if (!target) { library.classList.remove('is-reading'); chapters.forEach(ch => ch.hidden = false); guideNav.innerHTML=''; return; }
    library.classList.add('is-reading');
    chapters.forEach(ch => ch.hidden = ch !== target);
    reader.querySelector('[data-ck-reader-title]').textContent = target.querySelector('h2')?.textContent || '';
    const i = chapters.indexOf(target), prev = chapters[i-1], next = chapters[i+1];
    guideNav.innerHTML = `${prev ? `<a href="#${prev.id}"><span>Anterior</span><strong>${prev.querySelector('h2').textContent}</strong></a>` : '<span></span>'}${next ? `<a href="#${next.id}"><span>Următor</span><strong>${next.querySelector('h2').textContent}</strong></a>` : '<span></span>'}`;
    document.title = `${target.querySelector('h2')?.textContent || 'Corsaille Knowledge'} — Corsaille`;
    requestAnimationFrame(() => {
      const readingStart = target.querySelector('.ck-chapter__body > section:first-child > h3, .ck-chapter__body > section:first-child, .ck-chapter__body') || target;
      const readerHeight = reader.getBoundingClientRect().height || 0;
      const top = readingStart.getBoundingClientRect().top + window.scrollY - readerHeight - 26;
      window.scrollTo({top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      readingStart.setAttribute('tabindex', '-1');
      setTimeout(() => readingStart.focus({preventScroll:true}), 420);
    });
  };

  library.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (!chapters.some(chapter => chapter.id === id)) return;
    event.preventDefault();
    history.pushState(null, '', `#${id}`);
    setReading(id);
  });

  const fromHash = () => setReading(location.hash.slice(1));
  addEventListener('hashchange', fromHash);
  if (location.hash && chapters.some(ch => `#${ch.id}` === location.hash)) fromHash();

  reader.querySelector('[data-ck-reader-back]').addEventListener('click', () => {
    history.pushState(null,'',location.pathname + location.search);
    library.classList.remove('is-reading'); chapters.forEach(ch => ch.hidden = false); guideNav.innerHTML=''; document.title = originalTitle;
    document.querySelector('.ck-library__head')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
  reader.querySelector('[data-ck-copy]').addEventListener('click', async event => {
    try { await navigator.clipboard.writeText(location.href); event.currentTarget.textContent='Link copiat'; setTimeout(()=>event.currentTarget.textContent='Copiază linkul',1600); } catch (_) {}
  });
  reader.querySelector('[data-ck-print]').addEventListener('click', () => print());

  // Filtering is owned by the Pass 56 controller below; the previous layered handler was removed.


  const advisor = library.querySelector('[data-ck-advisor]');
  if (advisor) {
    const routes = {
      'shape:visual':['#forma-diamantului','Cum alegi forma diamantului','Compară silueta, proporția și prezența pe mână înainte de grade.'],'shape:daily':['#diamant-rotund','Diamantul rotund','O formă versatilă, ușor de protejat și de integrat în monturi diferite.'],'shape:value':['#carataj-dimensiune','Carataj și dimensiune vizuală','Compară milimetrii și suprafața frontală, nu doar greutatea.'],'setting:visual':['#solitaire-vs-halo','Solitaire, halo sau hidden halo?','Vezi ce adaugă fiecare arhitectură impresiei frontale.'],'setting:daily':['#montura-low-profile','Montura low-profile','Începe cu profilul, agățarea și relația cu viitoarea verighetă.'],'setting:value':['#montura-solitaire','Montura solitaire','Păstrează accentul și bugetul în piatra centrală.'],'diamond:visual':['#taietura-proportii','Tăietura și proporțiile diamantului','Frumusețea observabilă începe cu distribuția luminii.'],'diamond:daily':['#claritate-diamant','Claritatea fără anxietate','Selectează o piatră curată la ochi fără a plăti automat pentru raritate invizibilă.'],'diamond:value':['#cum-alegi-diamantul','Cum alegi diamantul potrivit','Prioritizează tăietura, apoi optimizează culoarea și claritatea în context.'],'metal:visual':['#aur-galben','Aurul galben','Înțelege cum metalul schimbă întreaga compoziție.'],'metal:daily':['#aur-alb-vs-platina','Aur alb sau platină?','Compară întreținerea, greutatea, patina și service-ul.'],'metal:value':['#aur-14k-vs-18k','Aur de 14K sau 18K?','Alege aliajul după construcție, uzură și buget.']
    };
    const update = () => { const need=advisor.querySelector('[name="need"]:checked')?.value||'shape', priority=advisor.querySelector('[name="priority"]:checked')?.value||'visual', value=routes[`${need}:${priority}`]; if(!value)return; const link=advisor.querySelector('[data-ck-advisor-link]'),note=advisor.querySelector('[data-ck-advisor-note]'); link.href=value[0]; link.firstChild.textContent=`${value[1]} `; note.textContent=value[2]; };
    advisor.addEventListener('change',update); update();
  }

  const lab = library.querySelector('[data-ck-lab]');
  if (lab) {
    const map = {'light:size':[['Tăietură și performanța luminii','Milimetri și proporție pe mână','Culoare și claritate în context','Montură și metal'],'#prioritati-4c'],'light:maintenance':[['Tăietură și contrast','Montură protejată','Metal și finisaj','Plan de service'],'#stil-viata-inel'],'light:budget':[['Tăietură observabilă','Dimensiune în milimetri','G–H și claritate eye-clean','Solitaire eficient'],'#cum-compari-doua-diamante'],'daily:size':[['Profil low-profile','Protecția conturului','Dimensiune frontală','Compatibilitate cu verigheta'],'#montura-low-profile'],'daily:maintenance':[['Arhitectură simplă','Gheare sau bezel','Metal și patină','Rutina de verificare'],'#intretinere-gheare'],'daily:budget':[['Construcție robustă','Claritate suficientă','Metal potrivit','Service documentat'],'#stil-viata-inel'],'rarity:size':[['Origine și raport','Dimensiune în milimetri','Culoare/claritate rare','Montură care protejează'],'#diamant-natural-origine'],'rarity:maintenance':[['Raport și identificare','Inscripție laser','Montură serviceable','Asigurare și documente'],'#inscriptie-laser'],'rarity:budget':[['Definește originea','Alege raritatea vizibilă','Evită grade invizibile','Păstrează rezervă pentru service'],'#eticheta-bugetului']};
    const update=()=>{const p=lab.querySelector('[name="ck-primary"]:checked')?.value||'light',q=lab.querySelector('[name="ck-secondary"]:checked')?.value||'size',value=map[`${p}:${q}`];if(!value)return;lab.querySelector('[data-ck-lab-steps]').innerHTML=value[0].map(step=>`<li>${step}</li>`).join('');lab.querySelector('[data-ck-lab-link]').href=value[1];}; lab.addEventListener('change',update); update();
  }

  const checks = library.querySelector('[data-ck-checklist]');
  if (checks) {
    const key='corsailleKnowledgeChecklistV2'; let saved=[]; try{saved=JSON.parse(localStorage.getItem(key)||'[]')}catch(_){}
    checks.querySelectorAll('input').forEach(input=>{input.checked=saved.includes(input.value);input.addEventListener('change',()=>{const values=[...checks.querySelectorAll('input:checked')].map(i=>i.value);try{localStorage.setItem(key,JSON.stringify(values))}catch(_){}})});
  }

  const bar=document.createElement('div');bar.className='ck-reading-progress';bar.setAttribute('aria-hidden','true');bar.innerHTML='<span></span>';document.body.appendChild(bar);const fill=bar.firstElementChild;let ticking=false;
  const paint=()=>{const active=library.querySelector('.ck-chapter:not([hidden])')||library;const start=active.offsetTop,length=Math.max(1,active.offsetHeight-innerHeight),progress=Math.min(1,Math.max(0,(scrollY-start)/length));fill.style.width=`${progress*100}%`;ticking=false;};
  addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(paint);ticking=true}},{passive:true});paint();
})();


// Pass 48: reader navigation and discreet editorial motion.
(() => {
  const faq = document.querySelector('[data-ck-faq]');
  if (faq) {
    const faqInput = faq.querySelector('[data-ck-faq-search]');
    const faqItems = [...faq.querySelectorAll('[data-ck-faq-item]')];
    const faqEmpty = faq.querySelector('[data-ck-faq-empty]');
    faqInput?.addEventListener('input', () => {
      const query = slugify(faqInput.value).replace(/-/g, ' ');
      let visible = 0;
      faqItems.forEach(item => {
        const text = slugify(item.textContent).replace(/-/g, ' ');
        const show = !query || query.split(/\s+/).every(token => text.includes(token));
        item.hidden = !show;
        if (show) visible++;
      });
      if (faqEmpty) faqEmpty.hidden = visible > 0;
    });
  }

  const library = document.querySelector('[data-ck-library]');
  if (!library) return;
  const back = document.createElement('button');
  back.className = 'ck-back-top'; back.type = 'button'; back.setAttribute('aria-label','Înapoi sus'); back.textContent = '↑';
  document.body.appendChild(back);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  addEventListener('scroll', () => back.classList.toggle('is-visible', scrollY > 900), {passive:true});
  back.addEventListener('click', () => document.querySelector('#knowledge-top, .ck-library')?.scrollIntoView({behavior:reduced?'auto':'smooth'}));

  const installChapterToc = chapter => {
    const body = chapter.querySelector('.ck-chapter__body');
    const hero = chapter.querySelector('.ck-chapter__hero');
    if (!body || !hero || chapter.querySelector('.ck-quick-toc')) return;
    const headings = [...body.querySelectorAll(':scope > section > h3')];
    if (headings.length < 2) return;
    const toc = document.createElement('nav'); toc.className = 'ck-quick-toc'; toc.setAttribute('aria-label','În acest ghid');
    toc.innerHTML = '<strong>În acest ghid</strong>';
    headings.forEach((heading,index) => {
      if (!heading.id) heading.id = `${chapter.id}-reper-${index+1}`;
      const a=document.createElement('a'); a.href=`#${heading.id}`; a.textContent=heading.textContent; toc.appendChild(a);
    });
    hero.querySelector('.ck-chapter__intro')?.appendChild(toc);
  };
  library.querySelectorAll('[data-ck-chapter]').forEach(installChapterToc);

  const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
    if(entry.isIntersecting){ entry.target.classList.add('is-revealed'); reveal.unobserve(entry.target); }
  }), {rootMargin:'0px 0px -8%'});
  library.querySelectorAll('.ck-card,.ck-paths a,.ck-library-index a,.ck-chapter__hero').forEach(el=>reveal.observe(el));
})();


// Pass 51: tactile inversion and direct knowledge navigation.
(() => {
  const interactive = document.querySelectorAll('.ck-card,.ck-destination-card,.ck-format-nav a,.ck-paths a,.ck-library-index a,.ck-related__item');
  interactive.forEach(item => {
    const clear = () => item.classList.remove('is-pressed');
    item.addEventListener('pointerdown', () => item.classList.add('is-pressed'), {passive:true});
    item.addEventListener('pointerup', clear, {passive:true});
    item.addEventListener('pointercancel', clear, {passive:true});
    item.addEventListener('pointerleave', clear, {passive:true});
  });
  document.querySelectorAll('.ck-nav a[href*="#"],.ck-destination-card[href^="#"],.ck-format-nav a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      const href = link.getAttribute('href');
      const hash = href && href.includes('#') ? `#${href.split('#').pop()}` : '';
      const target = hash && document.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      history.pushState(null,'',hash);
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });
  });
})();


// Pass 53: one-search architecture, FAQ topic shortcuts and active wayfinding.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const command = document.querySelector('[data-ck-command-form]');
  const commandInput = command?.querySelector('[data-ck-command-input]');
  const libraryInput = document.querySelector('[data-ck-library-search]');
  const runLibrarySearch = value => {
    const target = document.querySelector('#knowledge-search .ck-library-search, [data-ck-library-search]');
    if (libraryInput) {
      libraryInput.value = value;
      libraryInput.dispatchEvent(new Event('input', { bubbles:true }));
      libraryInput.closest('.ck-library-tools')?.scrollIntoView({ behavior:reduced?'auto':'smooth', block:'start' });
      setTimeout(() => libraryInput.focus({preventScroll:true}), reduced?0:450);
    } else if (target) target.scrollIntoView({behavior:reduced?'auto':'smooth'});
  };
  command?.addEventListener('submit', event => { event.preventDefault(); runLibrarySearch(commandInput?.value.trim() || ''); });
  document.querySelectorAll('[data-ck-command-query]').forEach(button => button.addEventListener('click', () => {
    if (commandInput) commandInput.value = button.dataset.ckCommandQuery || '';
    runLibrarySearch(button.dataset.ckCommandQuery || '');
  }));

  const faq = document.querySelector('[data-ck-faq]');
  if (faq) {
    const input = faq.querySelector('[data-ck-faq-search]');
    const items = [...faq.querySelectorAll('[data-ck-faq-item]')];
    const count = faq.querySelector('[data-ck-faq-count]');
    const topics = [...faq.querySelectorAll('[data-ck-faq-query]')];
    const updateCount = () => {
      const visible = items.filter(item => !item.hidden).length;
      if (count) count.textContent = input?.value ? `${visible} ${visible === 1 ? 'răspuns găsit' : 'răspunsuri găsite'}` : 'Răspunsurile cele mai căutate, într-un singur loc.';
    };
    input?.addEventListener('input', updateCount);
    topics.forEach(button => button.addEventListener('click', () => {
      const active = button.classList.contains('is-active');
      topics.forEach(item => item.classList.remove('is-active'));
      if (input) {
        input.value = active ? '' : (button.dataset.ckFaqQuery || '');
        if (!active) button.classList.add('is-active');
        input.dispatchEvent(new Event('input', {bubbles:true}));
      }
      updateCount();
    }));
  }

  const links = [...document.querySelectorAll('.ck-nav__links a[href*="#"]')];
  const pairs = links.map(link => {
    const hash = `#${(link.getAttribute('href') || '').split('#').pop()}`;
    return [link, document.querySelector(hash)];
  }).filter(([,target]) => target);
  if (pairs.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      links.forEach(link => link.removeAttribute('aria-current'));
      const match = pairs.find(([,target]) => target === entry.target);
      match?.[0].setAttribute('aria-current','true');
    }), {rootMargin:'-25% 0px -65% 0px'});
    pairs.forEach(([,target]) => observer.observe(target));
  }
})();

// Pass 55 — universal Knowledge search, anticipatory suggestions and precise sticky chrome.
(() => {
  const normalize = value => (value || '')
    .toLocaleLowerCase('ro-RO')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const localInput = document.querySelector('[data-ck-library]') ? document.querySelector('[data-ck-global-input]') : null;
  const faqInput = document.querySelector('[data-ck-faq-search]');
  const indexLinks = [...document.querySelectorAll('[data-ck-index]')];
  const staticSuggestions = [
    {title:'Ghidul complet al inelului de logodnă', category:'Cumpărare', href:'/blogs/corsaille-knowledge/ghid-inel-logodna', keys:'inel logodna ghid buget comanda romania'},
    {title:'Cum alegi diamantul potrivit', category:'Optică', href:'/blogs/corsaille-knowledge/cum-alegi-diamantul', keys:'diamant taietura lumina proportii carat claritate'},
    {title:'Diamant natural sau creat în laborator?', category:'Origine & valoare', href:'/blogs/corsaille-knowledge/natural-vs-laborator', keys:'natural laborator origine raritate valoare revanzare'},
    {title:'Aur alb sau platină?', category:'Atelier & monturi', href:'/blogs/corsaille-knowledge/aur-alb-vs-platina', keys:'aur alb platina metal montura atelier intretinere'},
    {title:'Cum afli mărimea inelului', category:'Mărime & fit', href:'/blogs/corsaille-knowledge/marime-inel', keys:'marime fit masor inel deget ergonomie'},
    {title:'Cum citești certificatul unui diamant', category:'Certificare', href:'/blogs/corsaille-knowledge/certificat-diamant', keys:'certificat raport gia igi inscriptie identitate'},
    {title:'Cum îngrijești un inel cu diamant', category:'Îngrijire', href:'/blogs/corsaille-knowledge/ingrijire-inel-diamant', keys:'ingrijire curatare inspectie reparatie diamant inel'},
    {title:'Inelul și viitoarea verighetă', category:'Verighete', href:'/blogs/corsaille-knowledge/verigheta-compatibilitate', keys:'verigheta set compatibilitate profil distanta uzura'},
    {title:'Cum alegi cerceii solitaire cu diamante', category:'Cercei', href:'/blogs/corsaille-knowledge/cum-alegi-cerceii-solitaire-cu-diamante', keys:'cercei solitaire diamante carat ureche inchidere'},
    {title:'Diamante colorate: ghidul complet al culorii fancy', category:'Diamante colorate', href:'/blogs/corsaille-knowledge/diamante-colorate-ghidul-complet-al-culorii-fancy', keys:'diamante colorate fancy nuanta ton saturatie'}
  ];
  const dynamic = indexLinks.map(link => ({
    title: link.querySelector('strong')?.textContent.trim() || link.textContent.trim(),
    category: link.dataset.category || link.querySelector('small')?.textContent.trim() || 'Ghid',
    href: link.getAttribute('href') || '#',
    keys: `${link.textContent} ${link.dataset.category || ''}`
  }));
  const catalogue = [...dynamic, ...staticSuggestions].filter((item, index, array) => array.findIndex(other => other.title === item.title) === index);

  const score = (item, query) => {
    const q = normalize(query); if (!q) return 0;
    const hay = normalize(`${item.title} ${item.category} ${item.keys}`);
    const tokens = q.split(' ').filter(Boolean);
    let total = hay.includes(q) ? 12 : 0;
    tokens.forEach(token => {
      if (normalize(item.title).startsWith(token)) total += 7;
      else if (normalize(item.title).includes(token)) total += 5;
      else if (hay.includes(token)) total += 2;
    });
    return total;
  };

  document.querySelectorAll('[data-ck-global-search]').forEach(form => {
    const input = form.querySelector('[data-ck-global-input]');
    const panel = form.querySelector('[data-ck-global-suggestions]');
    if (!input || !panel) return;
    const render = () => {
      const query = input.value.trim();
      const results = query.length < 2 ? [] : catalogue.map(item => ({...item, rank:score(item,query)})).filter(item => item.rank > 0).sort((a,b) => b.rank-a.rank).slice(0,6);
      panel.innerHTML = results.map(item => `<a href="${item.href}"><strong>${item.title}</strong><small>${item.category}</small></a>`).join('');
      panel.hidden = results.length === 0;
    };
    input.addEventListener('input', render);
    input.addEventListener('focus', render);
    document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) panel.hidden = true; });
    input.addEventListener('keydown', event => { if (event.key === 'Escape') { panel.hidden = true; input.blur(); } });
    form.addEventListener('submit', event => {
      const value = input.value.trim();
      if (!value) { event.preventDefault(); input.focus(); return; }
      if (localInput) {
        event.preventDefault();
        localInput.value = value;
        localInput.dispatchEvent(new Event('input', {bubbles:true}));
        document.querySelector('#knowledge-guides-index')?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
        panel.hidden = true;
      }
    });
  });

  const params = new URLSearchParams(location.search);
  const incoming = params.get('knowledge_q');
  if (incoming && localInput) {
    localInput.value = incoming;
    localInput.dispatchEvent(new Event('input', {bubbles:true}));
    requestAnimationFrame(() => document.querySelector('#knowledge-guides-index')?.scrollIntoView({behavior:'auto',block:'start'}));
  } else if (incoming && faqInput) {
    faqInput.value = incoming;
    faqInput.dispatchEvent(new Event('input', {bubbles:true}));
  }

  const chrome = document.querySelector('[data-ck-knowledge-chrome]');
  if (chrome) {
    const update = () => chrome.classList.toggle('is-scrolled', scrollY > 16);
    addEventListener('scroll', update, {passive:true}); update();
  }
})();


// Pass 56 — one fixed Knowledge chrome, one search source, real category filtering.
(() => {
  const library = document.querySelector('[data-ck-library]');
  const search = document.querySelector('[data-ck-global-input]');
  const hasKnowledgeChrome = Boolean(document.querySelector('[data-ck-knowledge-chrome]'));
  const filterButtons = [...document.querySelectorAll('[data-ck-global-filters] [data-ck-filter]')];
  const clear = document.querySelector('[data-ck-clear-filters]');
  const normalize = value => (value || '').toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();

  document.documentElement.classList.add('ck-knowledge-document');
  document.body.classList.add('ck-knowledge-page');
  document.documentElement.classList.toggle('ck-knowledge-has-chrome', hasKnowledgeChrome);
  document.body.classList.toggle('ck-knowledge-has-chrome', hasKnowledgeChrome);

  document.querySelectorAll('[data-ck-focus-search]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    search?.focus({preventScroll:true});
  }));

  if (!library || !search) {
    filterButtons.forEach(button => button.addEventListener('click', () => {
      const value = button.dataset.ckFilter || 'all';
      location.href = '/blogs/corsaille-knowledge';
    }));
    return;
  }

  const indexItems = [...library.querySelectorAll('[data-ck-index]')];
  const chapters = [...library.querySelectorAll('[data-ck-chapter]')];
  const status = library.querySelector('[data-ck-search-status]');
  const empty = library.querySelector('[data-ck-empty]');
  let activeCategory = filterButtons.find(button => button.classList.contains('is-active'))?.dataset.ckFilter || 'all';

  const matchesText = (chapter, query) => {
    if (!query) return true;
    const haystack = normalize(`${chapter.dataset.search || ''} ${chapter.dataset.category || ''} ${chapter.querySelector('h2')?.textContent || ''}`);
    return normalize(query).split(/\s+/).filter(Boolean).every(token => haystack.includes(token));
  };

  const applyPrecisely = () => {
    const query = search.value;
    let visible = 0;
    chapters.forEach((chapter, index) => {
      const categoryMatch = activeCategory === 'all' || normalize(chapter.dataset.category) === normalize(activeCategory);
      const show = categoryMatch && matchesText(chapter, query);
      chapter.hidden = !show;
      chapter.classList.toggle('is-filtered-out', !show);
      const card = indexItems[index];
      if (card) {
        card.hidden = !show;
        card.classList.toggle('is-filtered-out', !show);
        card.setAttribute('aria-hidden', String(!show));
      }
      if (show) visible += 1;
    });
    if (empty) empty.hidden = visible > 0;
    if (status) {
      const suffix = activeCategory !== 'all' ? ` în ${activeCategory.toLocaleLowerCase('ro-RO')}` : '';
      status.textContent = `${visible} ${visible === 1 ? 'ghid găsit' : 'ghiduri găsite'}${suffix}`;
    }
    if (clear) clear.hidden = !query && activeCategory === 'all';
  };

  search.addEventListener('input', applyPrecisely);
  filterButtons.forEach(button => button.addEventListener('click', () => {
    activeCategory = button.dataset.ckFilter || 'all';
    filterButtons.forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    applyPrecisely();
  }));
  clear?.addEventListener('click', () => {
    search.value = '';
    activeCategory = 'all';
    filterButtons.forEach(item => {
      const active = item.dataset.ckFilter === 'all';
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    applyPrecisely();
    search.focus({preventScroll:true});
  });

  const incomingCategory = new URLSearchParams(location.search).get('knowledge_category');
  if (incomingCategory) {
    const match = filterButtons.find(item => normalize(item.dataset.ckFilter) === normalize(incomingCategory));
    match?.click();
  }
  applyPrecisely();
})();
